import {firestore} from '@web/lib/firebase'
import { doc } from 'firebase/firestore'
import { useDocumentData } from 'react-firebase-hooks/firestore'
export default function useDocumentFirestore(collectionName, documentId) {
  return useDocumentData(!!documentId && doc(firestore, collectionName, documentId) || null)
}